export const allQRCodeIdUser = {
    GET_AllQRCodeIdUser: "GET_AllQRCodeIdUser",
     ADD_AllQRCodes: "ADD_AllQRCodes"

}